import { Component, Input, OnInit } from '@angular/core';
import { DeviceDetectorService } from '../../services/device-detector/device-detector.service';

@Component({
  selector: 'no-result',
  templateUrl: './no-result-page.component.html',
  styleUrls: ['./no-result-page.component.scss']
})
export class NoResultPageComponent implements OnInit {
  @Input('isWalletPage') isWalletPage: boolean = false;
  isDesktop: boolean = false;

  constructor(
    private deviceDetectorService: DeviceDetectorService,
  ) {
    this.isDesktop = this.deviceDetectorService.isDesktop;
  }

  ngOnInit(): void {
  }

}
